export interface ModuleDay {
    day: number;
    date: string;
    year: number;
    month: number;
}

export interface ModuleData {
    end?: Date;
    date: Date;
    start?: Date;
    event?: MouseEvent;
}

export const ModulePickerEmits = {
    change: (_data: { start?: Date; end?: Date }) => true,
    update: (_data: { year?: number; month?: number }) => true,
    message: (_data: { start?: Date; end?: Date }) => true,
    switchover: (_mode: string) => true,
};
